import React from "react";
import {
  Form,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  FormInput
} from "shards-react";
import AdsComponent from '../../../components/Ads.js';

export default () => (
  <Form className="main-navbar__search w-100 d-none d-md-flex d-lg-flex">
    <p>
      <div>
        <AdsComponent dataAdSlot='7653899393' />
      </div>
    </p>
  </Form>
);
